import { ErrorHandler, Injectable } from '@angular/core';
import { AppInsightsService } from './app-insights.service';

@Injectable({
	providedIn: 'root',
})
export class ErrorHandlerService extends ErrorHandler {
	constructor(private appInsightsService: AppInsightsService) {
		super();
	}

	handleError(error: Error): void {
		this.appInsightsService.logException(error); // Manually log exception
		console.log('from error handling', error);
		const originalError = this.getOriginalError(error);
		if (originalError !== error) {
			this.appInsightsService.logException(originalError); // Manually log original exception
		}
	}

	private getOriginalError(err: any): any {
		let error = err;
		while (error?.originalError) {
			error = error.originalError;
		}
		return error;
	}
}
